import { render, staticRenderFns } from "./CopyrightApplicationDetails.vue?vue&type=template&id=218ebaaa&scoped=true&"
import script from "./CopyrightApplicationDetails.vue?vue&type=script&lang=js&"
export * from "./CopyrightApplicationDetails.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightApplicationDetails.vue?vue&type=style&index=0&id=218ebaaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218ebaaa",
  null
  
)

export default component.exports